import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PowerGenerationSourceForm from '../Forms/PowerGenerationSourceForm';

const AddEditPowerGenerationSourceModal = ({
	dataPowerGenerationSource,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	edit_environment
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Fuente de Generación de Energía
			</ModalHeader>

			<PowerGenerationSourceForm
				dataPowerGenerationSource={dataPowerGenerationSource}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				edit_environment={edit_environment}
			/>
		</Modal>
	);
};

export default AddEditPowerGenerationSourceModal;
